<template>
  <div class="contactUs">
    <div class="contact"> </div>
    <div class="occupy"></div>
    <div class="container-box">
      <div class="container-address">
        <div><img src="https://file.njsyue.com/fs/data/homeimgs/address.png"><span>南京市雨花台区软件大道180号南京大数据产业基地</span></div>
        <div><img src="https://file.njsyue.com/fs/data/homeimgs/email.png"><span>dylan_sun@njsyue.com</span></div>
      </div>
      <div id="container" class="container" style="width: 100%; height: 500px">
        <amap cache-key="map" ref="map" map-style="amap://styles/whitesmoke" async :zoom.sync="zoom" :center.sync="center" :pitch.sync="pitch"
          :rotation.sync="rotation" :show-indoor-map="false">

          <amap-marker :position="position2" :offset="[0, 0]" :anchor="anchor" />
        </amap>
      </div>
    </div>
    <div class="bottomBar">
      <div>公司地址：南京市雨花台区软件大道180号南京大数据产业基地</div>
      <div>联系电话： 15805163017 黄女士</div>
      <div>版权所有：南京拾越信息科技有限公司</div>
      <div class="bottomBar-links">
        <span @click="go">备案号：苏ICP备17008551号</span>
        <span class="bottomBar-separator">|</span>
        <span @click="goPrivacy">通用隐私政策</span>
        <span class="bottomBar-separator">|</span>
        <span @click="goSsoPrivacy">统一登录服务隐私政策</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "contactUs",
  data () {
    return {
      center: [118.752279, 31.973338],
      position: [118.752279, 31.973338],
      // center: [118.751255, 31.972259],
      // position: [118.751255, 31.972259],

      zoom: 18,
      pitch: 45,
      rotation: 15,
      position2: [118.752279, 31.973338],
      // position2: [118.751255, 31.972259], // 七号楼
      anchor: "center",
    };
  },
  methods: {
    go () {
      location.href = "https://beian.miit.gov.cn";
    },
    goPrivacy () {
      location.href = "https://www.njsyue.com/user/privacy.html";
    },
    goSsoPrivacy () {
      location.href = "https://www.njsyue.com/user/privacy-sso.html";
    }
  }
};
</script>
<style lang="less" scoped>
.contactUs {
  width: 100%;
  height: calc(100vh - 100px);
  position: relative;
  overflow: overlay;
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 14px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
    display: none;
  }

  // &::-webkit-scrollbar-thumb {
  //     /*滚动条里面小方块*/
  //     // border-radius: 14px;
  //     // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  //     background: rgba(0, 0, 0, 0.2);
  // }

  // &::-webkit-scrollbar-track {
  //     /*滚动条里面轨道*/
  //     // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
  //     border-radius: 10px;
  //     // background: #f7f8fb;
  // }
  .contact {
    width: 100%;
    height: 630px;
    background-image: url("https://file.njsyue.com/fs/data/homeimgs/contactBg.png");
    background-position: center center;
    background-size: 100%;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .container-box {
    position: absolute;
    top: 205px;
    width: 100%;
    height: 790px;
    padding: 0 10%;
  }
  .occupy {
    height: 365px;
    position: relative;
  }
  .container {
    width: 100%;
    flex-grow: 1;
  }
  .container-address {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 110px;
    background: #ffffff;
    > div {
      text-align: left;
      width: 50%;
      font-family: MicrosoftYaHei;
      font-size: 18px;
      color: #082143;
      line-height: 24px;
      text-align: left;
      font-style: normal;
      padding: 0 39px;
      > img {
        width: 26px;
        margin-right: 11px;
      }
    }
  }
}
</style>
